module.exports = __webpack_public_path__ + "img/close.a2896704.svg";